import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import classNames from 'classnames'
import type {
  ICommunicationMethods,
  ILandingApplyingOfferPreferredConnections,
} from '@/components/composed/landingBlocks/LandingApplyingOfferPreferredConnections/types'
import { Button, Image } from '@/components/ui'
import { RadioButton } from '@/components/ui/ReactHookFormFields'
import { messages } from './messages'
import './styles.scss'

export const LandingApplyingOfferPreferredConnections: React.FC<ILandingApplyingOfferPreferredConnections> = ({
  handleSelectedMethod,
  isButtonDisable,
  className,
}) => {
  const [selectedMethod, setSelectedMethod] = useState<ICommunicationMethods>({
    communicationMethods: messages.communicationMethodData.phone,
  })
  const methods = useFormContext()

  useEffect(() => {
    methods.setValue('communicationMethod', selectedMethod.communicationMethods)
  }, [selectedMethod, methods])

  const handleSelect = (method: ICommunicationMethods) => {
    setSelectedMethod(method)
    methods.setValue('communicationMethod', method)
  }

  return (
    <div className={classNames(className, 'LandingApplyingOfferPreferredConnections__container')}>
      <h3 className="LandingApplyingOfferPreferredConnections__title">{messages.preferedMethod}</h3>
      <div className="LandingApplyingOfferPreferredConnections__cardContainer">
        <div
          className={classNames('LandingApplyingOfferPreferredConnections__card', {
            'LandingApplyingOfferPreferredConnections__card--selected':
              selectedMethod.communicationMethods === messages.communicationMethodData.phone,
          })}
          onClick={() => handleSelect({ communicationMethods: messages.communicationMethodData.phone })}
        >
          <Image className="LandingApplyingOfferPreferredConnections__image" src="financingOffer/agent/connections/phone.png" isInStatic />
          <RadioButton
            className="LandingApplyingOfferPreferredConnections__radioButton"
            name="communicationMethod"
            control={methods.control}
            value={messages.communicationMethodData.phone}
            key={messages.communicationMethodData.phone}
            onChange={() => handleSelect({ communicationMethods: messages.communicationMethodData.phone })}
            CustomLabel={<h5 className="LandingApplyingOfferPreferredConnections__label">{messages.communicationMethod.phone}</h5>}
          />
        </div>
        <div
          className={classNames('LandingApplyingOfferPreferredConnections__card', {
            'LandingApplyingOfferPreferredConnections__card--selected':
              selectedMethod.communicationMethods === messages.communicationMethodData.email,
          })}
          onClick={() => handleSelect({ communicationMethods: messages.communicationMethodData.email })}
        >
          <Image className="LandingApplyingOfferPreferredConnections__image" src="financingOffer/agent/connections/email.png" isInStatic />
          <RadioButton
            className="LandingApplyingOfferPreferredConnections__radioButton"
            name="communicationMethod"
            control={methods.control}
            value={messages.communicationMethodData.email}
            key={messages.communicationMethodData.email}
            onChange={() => handleSelect({ communicationMethods: messages.communicationMethodData.email })}
            CustomLabel={<h5 className="LandingApplyingOfferPreferredConnections__label">{messages.communicationMethod.email}</h5>}
          />
        </div>
      </div>

      <Button
        isDisabled={isButtonDisable}
        onClick={handleSelectedMethod}
        modifiers={['green', 'full-width-mobile']}
        className="space-holder-top32"
      >
        {messages.select}
      </Button>
    </div>
  )
}
